import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.style.routebutton === 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "routebutton",
    style: _normalizeStyle($options.getrouteBtnstyle($props.style)),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.routebtnHandle && $options.routebtnHandle(...args))
  }, _toDisplayString($props.style.routebuttontext), 5)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["routelistWrap", [{
      'on': $data.showlistflag
    }, {
      'mobile': $props.isMobile
    }, {
      'useSvw': $props.id === 1
    }]])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "route-item",
      key: index
    }, [_createElementVNode("h4", null, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getTypeData($data.dataList, item.itemformdata.onlyid), (ditem, dindex) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass({
          'active': $data.rIndex === ditem.id
        }),
        key: dindex,
        onClick: $event => $options.routeClick(ditem)
      }, _toDisplayString(ditem.itemformdata.title), 11, _hoisted_1);
    }), 128))])]);
  }), 128))], 2)], 64);
}